import PropTypes from 'prop-types';
import React from 'react';
import { Form, Collapse } from 'react-bootstrap';
import Checkbox from '../../../../components/atoms/CheckBox';
import ContentSpacer from '../../../../components/atoms/ContentSpacer';
import SectionHeader from '../../../../components/molecules/SectionHeader';

const ReleaseOfInformation = (props) => {
  const {
    itemList,
    disabled,
    onChange,
    setRoiContact,
    setVerbalRoiContact,
    roiContacts,
    verbalRoiContacts,
  } = props;

  return (
    <section>
      <SectionHeader value="Release Of Information" />
      <ContentSpacer>

        {itemList.filter((item) => item.id === 'verbalroi').map((item) => (
          <>
            <Checkbox
              inline="true"
              type="checkbox"
              label="ROI - Discuss"
              name="releaseOfInformation"
              value={item.value}
              id="roi-discuss"
              checked={item.isChecked}
              disabled={item.isDisabled || disabled}
              onChange={onChange || item.onChange}
              key={item.id}
            />
            <Collapse in={item.isChecked}>
              <div>
                <ContentSpacer>
                  <Form.Select
                    className="w-25 m-2"
                    disabled={!item.isChecked}
                    name="verbalRoiContact"
                    onChange={(e) => setVerbalRoiContact(e.currentTarget.value)}
                  >
                    <option key="placeholder" hidden value>Select Verbal ROI Contact</option>
                    {
            verbalRoiContacts.map((roiContact) => (
              <option key={roiContact.clientVisitId} value={roiContact.clientVisitId}>
                {roiContact.contact}
              </option>
            ))
          }
                  </Form.Select>
                </ContentSpacer>
              </div>
            </Collapse>
          </>
        ))}
        {itemList.filter((item) => item.id === 'roi').map((item) => (
          <>
            <Checkbox
              type="checkbox"
              label="ROI - Medical Records"
              name="releaseOfInformation"
              value={item.value}
              id="roi-medical"
              checked={item.isChecked}
              disabled={item.isDisabled || disabled}
              onChange={onChange || item.onChange}
              key={item.id}
            />
            <Collapse in={item.isChecked}>
              <div>
                <ContentSpacer>
                  <Form.Select
                    className="w-25 m-2"
                    disabled={!item.isChecked}
                    name="roiContact"
                    onChange={(e) => setRoiContact(e.currentTarget.value)}
                  >
                    <option key="placeholder" hidden value>Select ROI Contact</option>
                    {
            roiContacts.map((roiContact) => (
              <option key={roiContact.clientVisitId} value={roiContact.clientVisitId}>
                {roiContact.contact}
              </option>
            ))
              }
                  </Form.Select>
                </ContentSpacer>
              </div>
            </Collapse>
          </>
        ))}
      </ContentSpacer>
    </section>
  );
};

export default ReleaseOfInformation;

ReleaseOfInformation.propTypes = {
  itemList: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  setRoiContact: PropTypes.func.isRequired,
  setVerbalRoiContact: PropTypes.func.isRequired,
  roiContacts: PropTypes.arrayOf(PropTypes.shape({
    clientVisitId: PropTypes.number.isRequired,
    contact: PropTypes.string.isRequired,
  })),
  verbalRoiContacts: PropTypes.arrayOf(PropTypes.shape({
    clientVisitId: PropTypes.number.isRequired,
    contact: PropTypes.string.isRequired,
  })),
};

ReleaseOfInformation.defaultProps = {
  disabled: false,
  onChange: null,
  roiContacts: [],
  verbalRoiContacts: [],
};
